//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'Modal',

    props: {
        innerClass: {
            type: String,
            required: false,
            default: '',
        },
        maxWidth: {
            type: String,
            required: false,
            default: 'sm:max-w-lg',
        },
      canClose: {
          type: Boolean,
          required: false,
          default: true
      }
    },

    data() {
        return {
            active: false,
        };
    },

    mounted() {
        this.active = true;
    },

    methods: {
        async destroy() {
            this.active = false;
            setTimeout(() => {
                this.$emit('close');
            }, 200);
        },
    },
};
